import React, { useMemo } from 'react';
import { ExamSearch } from '../../interfaces/exam';
import ExamSearchItem from './ExamSearchItem';
import SearchResultItem from './SearchResultItem';
import { Flex } from '../UI-CHAKRA/Flex';

interface ExamListProps {
  exams: ExamSearch[];
  onSelectExam(exam: ExamSearch): void;
}

export default function ExamList(props: ExamListProps) {
  const { exams, onSelectExam } = props;

  const list = useMemo(() => {
    if (!exams || exams.length === 0) return;

    return exams.map((exam: ExamSearch, index) => {
      return (
        <SearchResultItem onClick={() => onSelectExam(exam)} key={index}>
          <ExamSearchItem exam={exam} />
        </SearchResultItem>
      );
    });
  }, [exams, onSelectExam]);

  return <Flex flexDir={'column'}>{list}</Flex>;
}
